import styled from 'styled-components'
import { ScreenSizes } from 'src/styles'

export const Wrapper = styled.div`
  width: calc(100% - 8px);
  height: 100vh;
  transition: all 400ms ease-in-out;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;

  @media (min-width: ${ScreenSizes.lg}) {
    height: auto;
  }
`

Wrapper.displayName = 'Wrapper'
